import { FormType } from '../../../form-types';
import { WeightManagementAnswerField } from '../questions';

export const weightMng: FormType<WeightManagementAnswerField> = {
  name: 'Weight Management Consultation',
  questions: [
    // Start with sex assigned at birth
    {
      key: 'weightMng_genderIdentify',
      next: {
        condition: { 'weightMng_genderIdentify.female': true },
        key: 'weightMng_pregnancyStatus',
        els: 'weightMng_weightHeightBMI'
      }
    },

    // Pregnancy screening for females only
    {
      key: 'weightMng_pregnancyStatus',
      next: {
        condition: { 'weightMng_pregnancyStatus.yes': true },
        key: 'weightMng_ineligible', // Disqualifies
        els: 'weightMng_consentPregnancy'
      }
    },

    // Pregnancy consent for females who are not pregnant
    {
      key: 'weightMng_consentPregnancy',
      next: {
        condition: { 'weightMng_consentPregnancy.non_consent': true },
        key: 'weightMng_ineligible', // Disqualifies
        els: 'weightMng_weightHeightBMI'
      }
    },

    // Height and weight collection
    'weightMng_weightHeightBMI',

    // BMI consent (shown after BMI calculation)
    {
      key: 'weightMng_consentBmi',
      next: {
        condition: { 'weightMng_consentBmi.non_consent': true },
        key: 'weightMng_ineligible', // Disqualifies
        els: 'weightMng_startingWeight'
      }
    },

    // Weight history questions
    'weightMng_startingWeight',
    'weightMng_diagnosisTime',

    // Previous treatment history
    {
      key: 'weightMng_previousTreatment',
      next: {
        condition: { 'weightMng_previousTreatment.yes': true },
        key: 'weightMng_treatmentTypes',
        els: 'weightMng_currentApproach'
      }
    },

    // Treatment types (conditional on previous treatment = yes)
    {
      key: 'weightMng_treatmentTypes',
      next: {
        condition: { 'weightMng_treatmentTypes.other': true },
        key: 'weightMng_otherTreatment',
        els: 'weightMng_treatmentComplications'
      }
    },

    // Other treatment details (conditional on "other" selected)
    'weightMng_otherTreatment',

    // Treatment complications
    {
      key: 'weightMng_treatmentComplications',
      next: {
        condition: { 'weightMng_treatmentComplications.yes': true },
        key: 'weightMng_complicationsDetails',
        els: 'weightMng_currentApproach'
      }
    },

    // Complications details (conditional on complications = yes)
    'weightMng_complicationsDetails',

    // Current approach and symptoms
    'weightMng_currentApproach',
    'weightMng_weightSymptoms',
    'weightMng_activityLevel',
    'weightMng_dietaryModifications',

    // Medication contraindication screening
    {
      key: 'weightMng_metforminContraindications',
      next: {
        condition: {
          'weightMng_metforminContraindications.none': true
        },
        key: 'weightMng_additionalQuestions',
        els: 'weightMng_ineligible'
      }
    },
    // 'weightMng_bupropionContraindications',
    // 'weightMng_naltrexoneContraindications',
    // 'weightMng_acarboseContraindications',
    // 'weightMng_orlistatContraindications',
    // 'weightMng_sglt2Contraindications',

    // Additional questions
    'weightMng_additionalQuestions',

    // Treatment consent
    {
      key: 'weightMng_treatmentConsent',
      next: {
        condition: { 'weightMng_treatmentConsent.non_consent': true },
        key: 'weightMng_ineligible', // Disqualifies
        els: 'weightMng_truthfulnessConsent'
      }
    },

    // Final truthfulness consent
    {
      key: 'weightMng_truthfulnessConsent',
      next: {
        condition: { 'weightMng_truthfulnessConsent.non_consent': true },
        key: 'weightMng_ineligible', // Disqualifies
        els: 'weightMng_complete'
      }
    },

    'weightMng_ineligible',
    'weightMng_complete'
  ]
};
